export const CustomYAxisTick = ({ x, y, payload }: any) => {
  const maxLength = 25; // Maximum characters to show
  const text = payload.value;
  const displayText =
    text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;

  return (
    <g transform={`translate(${x},${y})`}>
      <title>{text}</title>
      <text
        x={0}
        y={0}
        dy={4}
        textAnchor="end"
        fill="var(--gray-900)"
        fontSize={12}
        className="font-medium"
      >
        {displayText}
      </text>
    </g>
  );
};
